<template>
  <dashboard-block
    title="Требует внимания"
    :loading="loading"
    :missing="!block"
    :min-height="234"
    skeleton="list-item-avatar@3"
  >
    <v-list
      v-if="block"
      class="dashboard-attention py-0"
    >
      <v-list-item
        v-for="row in rows"
        :key="row.route"
        :to="row.canOpen ? { name: row.route } : undefined"
        class="px-2"
      >
        <v-list-item-icon class="me-3">
          <v-icon :color="row.color">
            {{ row.icon }}
          </v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title
            class="text-body-2 text-wrap"
            :class="row.isCalm ? 'text--secondary' : 'text--primary'"
          >
            {{ row.title }}
          </v-list-item-title>
          <v-list-item-subtitle
            v-if="row.canOpen"
            class="text-caption"
          >
            {{ row.page }}
          </v-list-item-subtitle>
        </v-list-item-content>

        <v-list-item-action class="ms-3 flex-row align-center">
          <span
            v-if="row.count !== null"
            class="text-h6 font-weight-semibold"
            :class="row.isCalm ? 'text--disabled' : `${row.color}--text`"
          >{{ row.count }}</span>
          <v-icon
            v-if="row.canOpen"
            size="20"
            class="ms-1"
          >
            {{ icons.mdiChevronRight }}
          </v-icon>
        </v-list-item-action>
      </v-list-item>
    </v-list>
  </dashboard-block>
</template>

<script>
import {
  mdiAlertCircleOutline, mdiCheckCircleOutline, mdiChevronRight, mdiHelpCircleOutline, mdiLanDisconnect,
} from '@mdi/js'
import DashboardBlock from '@/views/dashboard/dashboard-block'
import { canOpenRoute } from '@/router'
import { toCountString } from '@/helpers/dashboard'

export default {
  name: 'DashboardAttention',
  components: { DashboardBlock },
  props: {
    block: { type: Object, default: null },
    loading: { type: Boolean, default: false },
  },
  data: () => ({
    icons: { mdiChevronRight },
  }),
  computed: {
    rows() {
      const {
        paidNotInDelivery, awaitingPaymentTooLong, awaitingPaymentMinutes, webHooksFailed,
      } = this.block

      const tooLong = awaitingPaymentMinutes === null
        ? 'Ждут оплаты слишком долго'
        : `Ждут оплаты дольше ${toCountString(awaitingPaymentMinutes)} мин`

      return [
        this.row({
          count: paidNotInDelivery,
          title: 'Оплачены, но в Delivery не попали',
          route: 'payment-reconciliation',
          page: 'Сверка оплат',
          color: 'error',
        }),
        this.row({
          count: awaitingPaymentTooLong,
          title: tooLong,
          route: 'order-list',
          page: 'Заказы',
          color: 'warning',
        }),
        this.row({
          count: webHooksFailed,
          title: 'Вебхуки с ошибкой обработки',
          unknownTitle: 'Сервис вебхуков не ответил',
          unknownIcon: mdiLanDisconnect,
          route: 'webhook-list',
          page: 'Вебхуки',
          color: 'error',
        }),
      ]
    },
  },
  methods: {
    row({
      count, title, unknownTitle, unknownIcon, route, page, color,
    }) {
      const link = { route, page, canOpen: canOpenRoute(route) }

      if (count === null) {
        return {
          ...link,
          count: null,
          title: unknownTitle || `${title}: нет данных`,
          icon: unknownIcon || mdiHelpCircleOutline,
          color: 'warning',
          isCalm: false,
        }
      }

      return count > 0
        ? {
          ...link, count: toCountString(count), title, icon: mdiAlertCircleOutline, color, isCalm: false,
        }
        : {
          ...link, count: '0', title, icon: mdiCheckCircleOutline, color: 'success', isCalm: true,
        }
    },
  },
}
</script>

<style lang="scss" scoped>
.dashboard-attention {
  background: transparent;

      ::v-deep .v-list-item {
    min-height: 64px;
  }

  ::v-deep .v-list-item__action {
    min-width: 0;
  }
}
</style>
